import { createStore, compose, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

const persistConfig = {
  key: 'PLM',
  storage,
  whitelist: ['PreviousDetails'], // only navigation will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const enhancers = [applyMiddleware(thunk)];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(persistedReducer, composeEnhancers(...enhancers));
const persistor = persistStore(store);
const storeWarpper = {
  store,
  persistor,
};

export default storeWarpper;
